module.exports = __webpack_public_path__ + "img/co-creation.50df2db9.png";